import React, { Suspense, lazy } from 'react';
import { HeroSection } from './HeroSection';
const IncludesSection = lazy(() => import('./IncludesSection').then(m => ({
  default: m.IncludesSection
})));
const PainPoints = lazy(() => import('./PainPoints').then(m => ({
  default: m.PainPoints
})));
const SolutionSection = lazy(() => import('./SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const BonusSection = lazy(() => import('./BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('./TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PurchaseSection = lazy(() => import('./PurchaseSection').then(m => ({
  default: m.PurchaseSection
})));
const PurchasePopup = lazy(() => import('./PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden" data-id="element-154">
      <div data-id="element-155">
        <HeroSection data-id="element-156" />
        <Suspense fallback={null} data-id="element-157">
          <IncludesSection data-id="element-158" />
          <PainPoints data-id="element-159" />
          <SolutionSection data-id="element-160" />
          <BonusSection data-id="element-161" />
          <TestimonialsSection data-id="element-162" />
          <PurchaseSection data-id="element-163" />
        </Suspense>
      </div>
      <Suspense fallback={null} data-id="element-164">
        <PurchasePopup data-id="element-165" />
      </Suspense>

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-166">
        <p data-id="element-167">
          © {new Date().getFullYear()} Mega Pack de Intervención
          Fonoaudiológica Infantil. Todos los derechos reservados.
        </p>
      </footer>
    </div>;
}